import { Flex, Message } from '@aws-amplify/ui-react';
import React from 'react';

export default function MessageComponent ({title, body, type, children}) {

  const styleDiv = children ? {marginTop: '50px'} : {};

  return (
    <Flex direction="column">
      <Message className={`message message-${type}`} colorTheme={type} heading={title}>
        <div style={styleDiv}>
        {body}
        </div>
        {children}
      </Message>
    </Flex>
  );
}
